import { z } from "zod";

const postImageSchema = z.object({
  r2Key: z.string().min(1),
  imageUrl: z.url(),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  sortOrder: z.number().int().min(0),
});

export const createPostSchema = z.object({
  caption: z.string().max(2000).optional(),
  images: z.array(postImageSchema).min(1).max(10),
});

export const updatePostSchema = z.object({
  caption: z.string().max(2000).optional().nullable(),
});

export const createCommentSchema = z.object({
  body: z.string().min(1).max(1000),
});

export type CreatePostInput = z.infer<typeof createPostSchema>;
export type UpdatePostInput = z.infer<typeof updatePostSchema>;
export type CreateCommentInput = z.infer<typeof createCommentSchema>;
